<div class="main-Content pagination">
  <!-- Filter Option (change)="OnStatusChange()" #Status="ngModel" [(ngModel)]="userStatus" -->
  <div class="form-group row">
    <div class="col-sm-3">
      <h3>My Subscription</h3>
    </div>
    <div class="col-sm-3"></div>
    <div class="col-sm-3"></div>
    <div class="col-sm-3">
      <select class="form-control" (change)="OnStatusChange()" #Status="ngModel" [(ngModel)]="userStatus" name="Status">
        <option value="all">All</option>
        <option value="active">Active</option>
        <option value="deleted">Deleted</option>
        <option value="suspended">Suspended</option>
      </select>
    </div>
  </div>
  <!-- changing to TempDataSource -->
  <table mat-table [dataSource]="filterDataSource" class="elevation">

    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="no">
      <th mat-header-cell *matHeaderCellDef style="padding-left: 20px">
        No
      </th>
      <td mat-cell *matCellDef="let element; let i = index" style="height: 50px; padding-left: 20px">
        {{paginator.pageSize * paginator.pageIndex + i + 1}}
      </td>
    </ng-container>

    <!-- Auto Renewal Status Column -->
    <ng-container matColumnDef="autoRenewal">
      <th mat-header-cell *matHeaderCellDef>Auto Renewal</th>
      <td mat-cell *matCellDef="let element" style="padding-left:20px">
        <span *ngIf="element.autoRenewEnabled" #tooltip="matTooltip" matTooltip="Enabled"
          class="green-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#2fda50" />
            </g>
          </svg>
        </span>
        <span *ngIf="!(element.autoRenewEnabled)" #tooltip="matTooltip" matTooltip="Disabled"
          class="grey-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#b6b3b3" />
            </g>
          </svg>
        </span>
      </td>
    </ng-container>

    <!-- Term Cycle Column -->
    <ng-container matColumnDef="termCycle">
      <th mat-header-cell *matHeaderCellDef style="padding-left:10px">Term Duration </th>
      <td mat-cell *matCellDef="let element" style="padding-left:20px">
        <!-- <span *ngIf="element.billingCycle === 'annual'" title="Trial" class="btn btn-primary">True</span> -->
        <!-- <span *ngIf="element.isTrial == false" title="NotTrial" class="btn btn-outline-info">False</span> -->
        <span>{{element.billingCycle | titlecase}}</span>
      </td>
    </ng-container>

    <!-- Renewal Date Column -->
    <ng-container matColumnDef="renewalDate">
      <th mat-header-cell *matHeaderCellDef style="padding-left: 5px">
        Renewal Date
      </th>
      <td mat-cell *matCellDef="let element" style="padding-left: 5px">
        <span *ngIf="element.autoRenewEnabled">{{ element.commitmentEndDate | date }}</span>
      </td>
      <!-- <router-outlet></router-outlet> -->
    </ng-container>


    <!-- Name Column -->
    <ng-container matColumnDef="license">
      <th mat-header-cell *matHeaderCellDef style="padding-left: 5px">
        License Name
      </th>
      <td mat-cell *matCellDef="let element" style="padding-left: 5px">
        <a style="color: #7ACEFF;" href="javascript:void(0)"> {{ element.friendlyName }} </a>
      </td>
      <router-outlet></router-outlet>
    </ng-container>

    <!-- Weight Column    "updateSub==true"-->
    <!-- INLINE TABLE EDIT -->
    <ng-container matColumnDef="licenseQuantity">
      <th mat-header-cell *matHeaderCellDef style="padding-left: 10px">
        Quantity
      </th>
      <td mat-cell *matCellDef="let element" style="padding-left: 40px">
        {{ element.quantity }}
      </td>
    </ng-container>

    <!-- For Edit Actions  {{element.quantity}}-->
    <!-- INLINE TABLE EDIT -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef style="padding-left: 10px">
        Actions
      </th>
      <td mat-cell *matCellDef="let element" style="padding-left: 10px">
        <!-- warning icon for annual alert -->
        <!-- <span style="margin-left: 15px" *ngIf="element.billingCycle==='annual'">
          <span #tooltip="matTooltip" matTooltip="contact csp support">
             fa fa-exclamation-triangle font18 text-danger || fa fa-lock  -->
            <!-- <i class="fa fa-lock font18 " style="color: #7ACEFF;" aria-hidden="true"></i>
          </span>
        </span> --> 
        <!-- disabling based on billing cycle -->
        <span style="margin-left: 15px">
          <span *ngIf="editSub" type="button" #tooltip="matTooltip" matTooltip="Edit" class="cursor"
            (click)="alertBts(); element.isEdit = true" href="javascript:void(0);">
            <i class="fa fa-pencil font18" aria-hidden="true"></i></span>&nbsp;
          <span *ngIf="element.isEdit">
            <!-- Changed from   "updateSub==true" removed max limit of 300 -->
            <input style="width: auto;" matInput type="number" min="1" required
              [(ngModel)]="element.upCount" />&nbsp;&nbsp;
            <span type="reset" #tooltip="matTooltip" matTooltip="Reset" name="reset-subscription" class="cursor"
              (click)="resetSub(); element.isEdit = false" style="margin-left: 8px">
              <i class="fa fa-times-circle font18" aria-hidden="true"></i></span>&nbsp;
            <span type="submit" #tooltip="matTooltip" matTooltip="Submit" name="update-subscription"
              id="update-subscription-btn" class="cursor" (click)="
                updateMySub(
                  element.upCount,
                  element.id,
                  element.quantity,
                  element.offerName,
                  element
                )
              " style="margin-left: 8px" aria-hidden="true"><i class="fa fa-check-circle font18"></i></span>
            <span *ngIf="loading" style="color: #7ACEFF;" class="spinner-border spinner-border-sm ml-3">
              <!-- <i class="fa fa-spinner fa-spin"></i> -->
            </span>
          </span>
        </span>
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef style="padding-left: 10px">
        Status
      </th>
      <span *ngIf="loading" class="spinner-border spinner-border-sm-2 mr-2"></span>
      <td mat-cell *matCellDef="let element" style="padding-left: 20px">
        <span *ngIf="element.status == 'active'" #tooltip="matTooltip" matTooltip="Active"
          class="green-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#2fda50" />
            </g>
          </svg>
        </span>
        <span *ngIf="element.status == 'deleted'" #tooltip="matTooltip" matTooltip="Deleted"
          class="red-bg FontWeight500">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#ff4b3d" />
            </g>
          </svg>
        </span>
        <span *ngIf="element.status == 'suspended'" class="orange-bg FontWeight500" #tooltip="matTooltip"
          matTooltip="Suspended">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#ffb000" />
            </g>
          </svg>
        </span>
        <span
          *ngIf="element.status === 'disabled' || element.status === 'none' || element.status === 'expired' || element.status === 'pending'"
          class="FontWeight500" #tooltip="matTooltip" matTooltip="{{element.status}}">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
            <g id="outline-calendar_today-24px" transform="translate(-2 -2)">
              <path id="Path_6947" data-name="Path 6947"
                d="M6.667,0h6.667A6.667,6.667,0,0,1,20,6.667v6.667A6.667,6.667,0,0,1,13.333,20H6.667A6.667,6.667,0,0,1,0,13.333V6.667A6.667,6.667,0,0,1,6.667,0Z"
                transform="translate(2 2)" fill="#b3b6b6" />
            </g>
          </svg>
        </span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <table>
    <tr *ngIf="total == 0">
      <td colspan="10" style="
          background-color: rgb(249, 216, 216);
          color: Red;
          text-align: center;
          height: 50px;
        ">
        No License Found !
      </td>
    </tr>
    <tr *ngIf="fetchLoader" style="height: 300px;">
      <td>
        <mat-progress-spinner strokeWidth="3" [color]="color" [mode]="mode" [value]="value" [diameter]="diameter"
          style="margin: auto;">
        </mat-progress-spinner>
      </td>
    </tr>
  </table>
  <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
  </mat-paginator>
</div>